import React, { useState, useEffect } from 'react';
import './skipLinks.scss';
import { useTranslation } from 'react-i18next';

declare global {
    interface Window {
        zE:any;
    }
}

const SkipLinks = () => {
  const { t } = useTranslation();
  const [mainId, setMainId] = useState<boolean>(false);
  const [navId, setNavId] = useState<boolean>(false);

  const focusChange = () => {
    if (document.getElementById('content').childElementCount) {
      setMainId(true);
    } else {
      setMainId(false);
    }
    if (document.getElementById('leftmenu_navigation') && document.getElementById('leftmenu_navigation').childElementCount) {
      setNavId(true);
    } else {
      setNavId(false);
    }
  }

  /* Polyfill: focus-within, Safari first skip link focus */
  const handleSkipLinkFocus = (e, type) => {
    const contentEl = document.getElementById('skip-link-content');
    const navEl = document.getElementById('skip-link-nav');
    if (type === 'add') {
      if (e.currentTarget.contains(e.target)) {
        contentEl?.classList.add('clip-path-focus');
        navEl?.classList.add('clip-path-focus-index');
      }
    } else if (type === 'remove') {
      if (!e.currentTarget.contains(e.relatedTarget)) {
        contentEl?.classList.remove('clip-path-focus');
        navEl?.classList.remove('clip-path-focus-index');
      }
    }
  }

  useEffect(() => {
    focusChange();
  }, []);

  // @ts-ignore
  const isVnextPage = window.isVnextPage();

  return (
    <div
      tabIndex={-1}
      id="skip-link-nav"
      className="skipLinks"
      onFocus={(e) => handleSkipLinkFocus(e, 'add')}
      onBlur={(e) => handleSkipLinkFocus(e, 'remove')}
    >
      <div className="skipLinkContent" id="skip-link-content">
        { mainId && (
        <a
          className="skipLink"
          href="#content"
          id="skipMain"
          onFocus={focusChange}
        >
          <div>{t("Skip to main content")}</div>
        </a>)}
        { navId && !isVnextPage && (
          <a
            className="skipLink"
            href="#leftmenu_navigation"
            id="skipNav"
            onFocus={focusChange}
          >
            <div>{t("Skip to secondary navigation")}</div>
          </a>
        )}
        <a
          className="skipLink"
          href="https://workboard.zendesk.com/hc/en-us"
          id="skipToHelp"
          target="_blank"
          rel="noopener noreferrer"
          onFocus={focusChange}
        >
          <div>{t("Go to Help Center")}</div>
        </a>
        {window.zE && (
          <div
            className="skipLink"
            id="skipToSupport"
            role="link"
            tabIndex={0}
            onFocus={focusChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault()
              }
            }}
          >
            <div>{t("Go to Chat Support")}</div>
          </div>)}
      </div>
    </div>
  );
}

export default SkipLinks;
